import { RouterProvider } from "react-router-dom";
import "zone.js";
import router from "./routes/routes";
import "/node_modules/bootstrap/dist/css/bootstrap.css";
import "./assets/fonts/DroidSans-Bold-webfont.ttf";
import "./assets/fonts/DroidSans-Bold-webfont.woff";
import "./assets/fonts/DroidSans-webfont.ttf";
import "./assets/fonts/DroidSans-webfont.woff";
import { Provider } from "react-redux";
import store from "./store/store";
import { ToastContainer, Slide } from "react-toastify";

// import DynamicAlert from "./components/DynamicAlert/DynamicAlert";

import "bootstrap-daterangepicker/daterangepicker.css";
import "./App.scss";
// import MessageAlert from "./components/Alerts/MessageAlert";

function App() {
  return (
    <Provider store={store}>
      {/* <MessageAlert /> */}
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      <RouterProvider router={router} />
    </Provider>
  );
}

export default App;
